// Production configuration
const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'production' 
      ? 'http://localhost:8000'  // Will be overridden by Docker environment
      : 'http://localhost:8000'),
  WS_BASE_URL: process.env.REACT_APP_WS_URL || 
    (process.env.NODE_ENV === 'production'
      ? 'ws://localhost:8000'    // Will be overridden by Docker environment
      : 'ws://localhost:8000')
};

export default config;
